// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3E6ww","location":"Header_location__1uT2R"};